'use strict';

function catalogRules() { // 服务目录
    return {
        title: [
            { required: true, message: '请填写目录名称', trigger: ['blur', 'change'] },
        ],
        companys: [
            { required: true, message: '请选择关联公司', trigger: ['change, blur'] },
        ],
        serviceShare: [
            { required: true, message: '请填写服务分值', trigger: ['blur', 'change'] },
        ]
    }
}

function bargainRules() { // 客户合同
    return {
        title: [
            { required: true, message: '请填写目录名称', trigger: ['blur', 'change'] },
        ],
        customer: [
            { required: true, message: '请选择客户', trigger: ['blur', 'change'] },
        ],
        warrantyStartTime: [
            { required: true, message: '请选择有效开始时间', trigger: ['blur', 'change'] },
        ],
        warrantyEndTime: [
            { required: true, message: '请选择有效到期时间', trigger: ['blur', 'change'] },
        ],
        cost: [
            { required: true, message: '请填写费用（单位万元）', trigger: ['blur', 'change'] },
        ],
        costType: [
            { required: true, message: '请选择货币类型', trigger: ['blur', 'change'] },
        ],
        paymentCycle: [
            { required: true, message: '请填写付款周期', trigger: ['blur', 'change'] },
        ],
        supplier: [
            { required: true, message: '请选择供应商', trigger: ['blur', 'change'] },
        ]
    }
}

function celevelRules() { // 服务水平协议
    return {
        title: [
            { required: true, message: '请填写名称', trigger: ['blur', 'change'] },
        ],
        servers: [
            { required: true, message: '请选择服务方', trigger: ['change', 'blur'] },
        ],
        contract: [
            { required: true, message: '请选择合同', trigger: ['change', 'blur'] },
        ]
    };
}

export {
    catalogRules,
    bargainRules,
    celevelRules
}